import { TypePermissionEntity } from "@/data/default/types/enumPermission";
import { RouteConfig } from "vue-router";
import RouterDirector from "@/data/default/types/RouterDirector";

const builder = RouterDirector.makeRouterWithPermission({
  name: "entidadeApoio",
  permissionEntity: TypePermissionEntity.ENTIDADE_APOIO,
  componentRoot: () => import("@/screens/default/entidadeApoio/Index.vue"),
  componentList: () => import("@/screens/default/entidadeApoio/List.vue"),
  componentSave: () => import("@/screens/default/entidadeApoio/Save.vue")
});

export const Router: RouteConfig[] = [builder.getRootRoute()];

export const routes = builder.getRouteNames();
